import { ConvexReactClient } from 'convex/react'
import { api } from '../../convex/_generated/api'
import type { Id } from '../../convex/_generated/dataModel'
import { isElectron, saveVideo } from './electron'
import { track } from './track'

let _convexClient: ConvexReactClient | null = null
export function bindDownloadClient(client: ConvexReactClient) {
  _convexClient = client
}

function checkFirstExport(workflowId: string) {
  if (!_convexClient) return
  _convexClient.mutation(api.track.checkActivationMilestone, {
    name: 'activation.first_export',
    workflowId: workflowId ? (workflowId as Id<'workflows'>) : undefined,
  }).catch(() => {})
}

export async function downloadVideo(
  url: string,
  suggestedName: string,
  opts: { workflowId?: string } = {},
): Promise<void> {
  const format = suggestedName.split('.').pop() ?? 'mp4'
  const workflowId = opts.workflowId ?? ''
  const start = Date.now()
  track('export.started', { workflowId, format })

  if (isElectron()) {
    const result = await saveVideo(url, suggestedName)
    if (result && 'canceled' in result) return
    track('export.completed', { workflowId, format, durationMs: Date.now() - start })
    checkFirstExport(workflowId)
    return
  }

  const response = await fetch(url)
  const blob = await response.blob()
  const blobUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = blobUrl
  a.download = suggestedName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(blobUrl)
  track('export.completed', { workflowId, format, durationMs: Date.now() - start })
  checkFirstExport(workflowId)
}
